import { Mode } from '../../types/mode'
import { isMode } from '../../utils/isMode'
import ChangesReportExport from '../ChangesReportExport/ChangesReportExport'
import Dump from '../Dump/Dump'

import Eval from './Eval/Eval'
import Urls from './Urls/Urls'

import styles from './admin.module.scss'

function Admin() {
    return (
        <main className={styles.admin}>
            <Urls />
            {isMode(Mode.ENHANCED) ? <Eval /> : null}
            <Dump />
            <ChangesReportExport />
        </main>
    )
}

export default Admin
